<mat-toolbar class="content-header">
    <mat-icon class="header-icon" fontIcon="source"></mat-icon>

    <h1 class="page-title" data-testid="project-title">{{'projects.allProjects' | translate}}</h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="container">
    <div class="option-menu margin-bottom">
        <div>
            <lib-button *ngIf="hasAdminAccess" (click)="reportsEnabling()" color="none" textColor="primary"
                text="{{ 'projects.reports.enabling' | translate }}" icon="summarize">
            </lib-button>
        </div>

        <div class="toggle-buttons">
            <div class="list-buttons">
                <lib-button icon="view_module" color="none" [textColor]="showList ? 'disabled' : 'primary'"
                    (click)="toggleShowList(false)" tooltip="{{'projects.card_view' | translate}}">
                </lib-button>

                <lib-button icon="view_list" color="none" [textColor]="showList ? 'primary' : 'disabled'"
                    (click)="toggleShowList(true)" tooltip="{{'projects.table_view' | translate}}">
                </lib-button>
            </div>

            <div class="list-buttons">
                <lib-button icon="archive" class="icon-crossed" color="none"
                    tooltip="{{'projects.archive.hide' | translate}}"
                    [textColor]="showArchived ? 'disabled' : 'primary'" (click)="listArchived(false)">
                </lib-button>

                <lib-button icon="archive" color="none" tooltip="{{'projects.archive.show' | translate}}"
                    [textColor]="showArchived ? 'primary' : 'disabled'" (click)="listArchived(true)">
                </lib-button>
            </div>
        </div>

        <div class="group">
            <lib-button *ngIf="canManageProject" (click)="addProject()" color="primary"
                tooltip="{{'projects.addProject' | translate}}" icon="add">
            </lib-button>

            <app-search-bar (searchText)="search($event)"></app-search-bar>
        </div>
    </div>

    <div class="project-table">
        <table mat-table [dataSource]="projectsData" matSort *ngIf="showList">
            <ng-container matColumnDef="fav">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content fav">
                        <mat-icon fontIcon="bookmark"></mat-icon>
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button *ngIf="!row.archived" (click)="toggleFavourite(row.id)">
                        <mat-icon [row.favourite]="favouriteProjects().includes(row.id)">
                            bookmark
                        </mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="source"></mat-icon>
                        {{'datatable.name' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" (click)="selectCurrentProject(row.id)" class="text-shadow">
                    {{row.name}}
                </td>
            </ng-container>

            <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="fingerprint"></mat-icon>
                        {{'settings.project.reference' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" (click)="selectCurrentProject(row.id)" class="text-shadow reference">
                    {{row.reference}}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="worker-column-width">
                    <div class="header-content">
                        <mat-icon fontIcon="wifi"></mat-icon>
                        {{'datatable.status' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row" [ngClass]="{'project-not-defined': !row.status}"
                    class="worker-column-width">
                    <div class="com-status">
                        <div *ngIf="!loading && row.status" class="chip-list">
                            <lib-chip *ngIf="row.status.communication==2" color="primary" icon="wifi"
                                text="{{'status.active' | translate}}" selected>
                            </lib-chip>

                            <lib-chip *ngIf="row.status.communication==1" color="warning" icon="wifi_off"
                                text="{{'status.inactive' | translate}}" selected>
                            </lib-chip>

                            <lib-chip *ngIf="row.status.communication==0" color="disabled" icon="wifi"
                                text="{{'status.unavailable' | translate}}">
                            </lib-chip>

                            <lib-chip *ngIf="row.status.last" icon="schedule" color="muted"
                                text="{{'status.last'|translate}} {{row.status.last|timeFormat:'PPp':user.language}}">
                            </lib-chip>
                        </div>

                        <div *ngIf="loading || !row.status" class="chip-list">
                            <lib-chip color="outline" icon="sync" text="{{'status.loading'|translate}}">
                            </lib-chip>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="units">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="devices"></mat-icon>
                        {{'resources.title' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    <div class="com-status">
                        <div *ngIf="!loading && row.status" class="chip-list">
                            <lib-chip
                                text="{{row.status.unitConnected}}/{{row.status.unitCount}} {{'trackers.connected'|translate}}"
                                color="outline" icon="devices">
                            </lib-chip>
                        </div>

                        <div *ngIf="loading">
                            <lib-chip color="outline" icon="sync" text="{{'status.loading'|translate}}">
                            </lib-chip>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="header-content">
                        <mat-icon fontIcon="calendar_today"></mat-icon>
                        {{'datatable.createdDate' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    {{row.createdDate | timeFormat:'yyyy/MM/dd'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="edit"></mat-icon>
                        {{'form.action' | translate}}
                    </div>
                </th>

                <td mat-cell *matCellDef="let row">
                    @if(!row.frozen) {
                    <lib-button color="none" textColor="primary" icon="launch" (click)="selectCurrentProject(row.id)"
                        tooltip="{{'projects.openProject' | translate}}">
                    </lib-button>

                    <lib-button *ngIf="row.archived && !processing[row.id]" color="none" textColor="secondary"
                        (click)="archiveProject(row)" tooltip="{{'projects.archive.undo' | translate}}"
                        icon="unarchive">
                    </lib-button>

                    <lib-button *ngIf="!row.archived && !processing[row.id]" color="none" textColor="warning"
                        icon="archive" (click)="archiveProject(row)" tooltip="{{'projects.archive.do' | translate}}">
                    </lib-button>

                    <app-spinner *ngIf="processing[row.id]" [diameter]="20" class="spinner">
                        <mat-icon class="spinner-icon" fontIcon="loop"></mat-icon>
                    </app-spinner>
                    }
                    @else {

                    <lib-button (click)="alertFrozen()" icon="ac_unit" color="none" textColor="secondary"
                        tooltip="{{ 'projects.frozen.tooltip' | translate }}">
                    </lib-button>
                    }

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="projectsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: projectsColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="projectsColumns.length">
                    <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                    </lib-no-data>
                </td>
            </tr>
        </table>

        <div *ngIf="!showList">
            <div *ngIf="projects.length > 0" class="cards-container">
                <mat-card class="project-card" *ngFor="let project of projects">
                    <img *ngIf="project.loading" mat-card-image [src]="'/img/image-placeholder.jpg'"
                        (click)="selectCurrentProject(project.id)" class="project-thumbnail skeleton"
                        alt="Project image placeholder">

                    <img *ngIf="!project.loading" mat-card-image [src]="project.thumbnail"
                        (click)="selectCurrentProject(project.id)" (error)="handleMissingImage($event)"
                        class="project-thumbnail" alt="Project's thumbnail">

                    <mat-card-content class="card-content">
                        <div class="card-content-header">
                            <div (click)="selectCurrentProject(project.id)" class="project-name-link">

                                <lib-button *ngIf="!project.archived" icon="bookmark" color="none"
                                    [textColor]="project.favourite ? 'primary' : 'disabled'"
                                    (click)="toggleFavourite(project.id)">
                                </lib-button>

                                <div class="titleProject" *ngIf="project.reference">
                                    <span class="nameProject">{{ showProjectName(project.name) }}</span>
                                    <span class="reference">{{showProjectName(project.reference)}}</span>
                                </div>

                                <span *ngIf="!project.reference" class="nameProject">{{ showProjectName(project.name)
                                    }}</span>
                            </div>

                            @if(!project.frozen) {
                            <div class="align">
                                <lib-button *ngIf="project.archived && !processing[project.id]" color="none"
                                    textColor="secondary" (click)="archiveProject(project)"
                                    tooltip="{{'projects.archive.undo' | translate}}" icon="unarchive">
                                </lib-button>

                                <lib-button *ngIf="!project.archived && !processing[project.id]" color="none"
                                    textColor="warning" icon="archive" (click)="archiveProject(project)"
                                    tooltip="{{'projects.archive.do' | translate}}">
                                </lib-button>
                            </div>
                            } @else {
                            <lib-button (click)="alertFrozen()" tooltip="{{ 'projects.frozen.tooltip' | translate }}"
                                icon="ac_unit" color="none" textColor="secondary">
                            </lib-button>
                            }
                        </div>

                        <div class="com-status">
                            <div class="chip-list card" *ngIf="!loading && project.status">
                                <lib-chip *ngIf="project.status?.communication==2" color="primary" icon="wifi"
                                    text="{{'status.active'|translate}}" selected>
                                </lib-chip>

                                <lib-chip *ngIf="project.status?.communication==1" color="warning" icon="wifi_off"
                                    text="{{'status.inactive'|translate}}" selected>
                                </lib-chip>

                                <lib-chip *ngIf="project.status?.communication==0" color="disabled" icon="highlight_off"
                                    text="{{'status.unavailable'|translate}}">
                                </lib-chip>

                                <lib-chip *ngIf="project.status.last" icon="schedule" color="muted"
                                    text="{{'status.last'|translate}} {{project.status.last|timeFormat:'PPp':user.language}}">
                                </lib-chip>
                            </div>

                            <div *ngIf="loading">
                                <lib-chip color="outline" icon="sync" text="{{'status.loading'|translate}}">
                                </lib-chip>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div *ngIf="!loading && projects.length === 0" class="no-data-wrapper">
                <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                </lib-no-data>
            </div>
        </div>

        <mat-paginator #projectPaginator [length]="projectsCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
            [ngClass]="!showList ? 'paginator-card' : ''" (page)="handlePageEvent($event)">
        </mat-paginator>

        <div *ngIf="loading" class="table-overlay">
            <app-spinner></app-spinner>
        </div>
    </div>
</div>
